"use client";

import { useSuspenseLoggedOutNavigationQuery } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useNavigationQuery";
import { ClientPlatformType } from "@faire/web-api--source/indigofair/data/ClientPlatformType";
import { Suspense, useMemo } from "react";

import {
  getNavigationBarDropdownLinks,
  getNavigationBarVisibleLinks,
} from "./__internal__/navigationQueryUtils";
import {
  NavigationLinksBar,
  NavigationLinksBarContainer,
} from "./NavigationLinksBar";

export const LoggedOutNavigationLinksBar: React.FC = () => {
  return (
    <Suspense fallback={<NavigationLinksBarContainer />}>
      <LoggedOutNavigationLinksBarBase />
    </Suspense>
  );
};

const LoggedOutNavigationLinksBarBase: React.FC = () => {
  const { navigationLinkGroup } = useSuspenseLoggedOutNavigationQuery(
    ClientPlatformType.CLIENT_DESKTOP
  );

  const visibleLinks = useMemo(
    () => getNavigationBarVisibleLinks(navigationLinkGroup),
    [navigationLinkGroup]
  );

  const dropdownLinks = useMemo(
    () => getNavigationBarDropdownLinks(navigationLinkGroup),
    [navigationLinkGroup]
  );

  return (
    <NavigationLinksBar
      nextPrefetchCategoryC1Route={() => {}}
      maybeAssignCategoryTreeExperimentForDropdown={() => {}}
      visibleLinks={visibleLinks}
      dropdownLinks={dropdownLinks}
    />
  );
};
